import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../../../../hooks'
import { MoneyInput } from '../../../../../../../../Currency'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../../../../Formik'
import {
  LISTING_PROFILE_KEY_FACT,
  LISTING_PROFILE_KEY_FACT_LABEL_KEY,
  LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS,
  LISTING_PROFILE_KEY_FACTS_PLACEHOLDER_KEY,
} from '../../../RentalPortalListingProfileKeyFactsWidget.constants'

function HeatingCostsField({ isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={MoneyInput}
      controlProps={{ borderless: !isMobileScreenSize }}
      fieldComponentProps={{
        isLoading,
        label: `${t(LISTING_PROFILE_KEY_FACT_LABEL_KEY[LISTING_PROFILE_KEY_FACT.heatingCosts])}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS}
      placeholder={t(
        LISTING_PROFILE_KEY_FACTS_PLACEHOLDER_KEY[
          LISTING_PROFILE_KEY_FACTS_FIELD_NAME_HEATING_COSTS
        ]
      )}
    />
  )
}

export default HeatingCostsField
